<template>
  <div class='msg'>
    <div class='msgbox' :class="{active: isinfo}">
    <p>请输入内容</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'msg',
  props: {
  },
  data() {
    return {
      isinfo: false,
    }
  },
  created() {

  },
  methods: {
  }
}
</script>

<style scoped>
.msgbox{
  width: 30%;
  height: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #000000;
  opacity: 0;
}
.msgbox p{
  text-align: center;
  color: #ffffff;
}
.active{
 opacity: 1
}
</style>


// WEBPACK FOOTER //
// src/plugins/msg.vue